import { render } from "./Page.vue?vue&type=template&id=8d7ede88&bindings={}"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import "./Page.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script